module.exports = __webpack_public_path__ + "img/equipment.5ebdb434.jpg";